import { drawColonialGrills } from './drawColonialGrills';

/**
 * drawCottageGrills - Draws colonial-style grills in the top portion of the glass.
 *
 * The cottageOption parameter determines what fraction of the height gets grills:
 *   "1/2" → top half
 *   "1/3" → top third
 *   "1/4" → top quarter
 *
 * All other parameters are identical to drawColonialGrills.
 */
export function drawCottageGrills(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  horLines = 1,
  verLines = 1,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  shape = 'rect',
  shapeOrientation = 'left',
  y1 = 0,
  y2 = 0,
  innerPoints,
  cottageOption = '1/4'
) {
  const fractionMap = {
    '1/2': 1 / 2,
    '1/3': 1 / 3,
    '1/4': 1 / 4,
  };
  const fraction = fractionMap[cottageOption] || 1 / 4;
  const cottageHeight = height * fraction;

  drawColonialGrills(
    svg,
    x,
    y,
    width,
    cottageHeight,
    frameWidth,
    horLines,
    verLines,
    lineColor,
    borderColor,
    borderWidth,
    grillThickness,
    shape,
    shapeOrientation,
    y1,
    y2,
    innerPoints
  );

  // Always draw the bottom horizontal line at the cottage boundary
  const bottomY = y + cottageHeight;
  svg.append('rect')
    .attr('x', x)
    .attr('y', bottomY - grillThickness / 2)
    .attr('width', width)
    .attr('height', grillThickness)
    .attr('fill', lineColor)
    .attr('stroke', borderColor)
    .attr('stroke-width', borderWidth);
}
